import { BoxProps, mobileNumber, required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { Dropdown } from '../../../../components/Dropdown'

const textinputStyle = {
  type: 'body12',
  borderColor: '#E0E0E0',
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#757575',
  labelFontSize: 12,
  fontSize: 12,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: 'BLACK_21',
} as unknown as BoxProps

export const profileDetails = () => [
  {
    actionTitle: 'Proceed',
    key: 'entityDetails',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'label1',
            ComponentName: TextInputNew,
            label: 'Label',
            placeholder: '',
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'businessName',
          },
          {
            fieldName: 'legalName',
            ComponentName: TextInputNew,
            label: 'Label',
            placeholder: '',
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'legalName',
          },
          {
            fieldName: 'ownerMobile',
            ComponentName: TextInputNew,
            label: 'Label',
            placeholder: '',
            validationSchema: mobileNumber,
            ...textinputStyle,
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'ownerMobile',
          },
          {
            fieldName: 'entityType',
            ComponentName: Dropdown,
            validationSchema: required,
            label: 'Entity Type',
            data: [
              { id: 1, value: 'Sole Prop' },
              { id: 2, value: 'Unit Head' },
              { id: 3, value: 'Manager' },
            ],
            testID: 'entityType',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'onboardingChannel',
            ComponentName: TextInputNew,
            label: 'Label',
            placeholder: '',
            width: '25%',
            validationSchema: required,
            ...textinputStyle,
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'onboardingChannel',
          },
          {
            fieldName: 'setupLevel',
            ComponentName: TextInputNew,
            label: 'Label',
            placeholder: '',
            validationSchema: required,
            ...textinputStyle,
            width: '25%',
            paddingVertical: 8,
            color: 'BLACK_21',
            testID: 'setupLevel',
          },
          {
            fieldName: 'spacer',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
